export default `# Drelo — Términos de Servicio (Borrador)

**Última actualización:** 23 de junio de 2026
**Operado por:** Pryma Wellness Group Inc., una Delaware Corporation (File #10417420), con domicilio registrado en 16192 Coastal Highway, Lewes, DE 19958, EE.UU. "Drelo" es un nombre comercial (DBA) de Pryma Wellness Group Inc.

---

## 1. Aceptación de los Términos

Al usar el sitio drelo.shop ("el Sitio") o comprar productos a través de él, aceptas estos Términos de Servicio, nuestra [Política de Privacidad](./02_Privacy_Policy.md), nuestra [Política de Envíos](./03_Shipping_Policy.md) y nuestra [Política de Devoluciones](./04_Return_Refund_Policy.md).

## 2. Quiénes somos

Drelo es una tienda en línea operada por Pryma Wellness Group Inc. que vende productos de terceros mediante un modelo de **dropshipping**: los productos se envían directamente desde nuestro proveedor (actualmente CJDropshipping) al cliente, no desde un almacén propio de Drelo.

## 3. Cuentas

Puedes comprar como invitado o creando una cuenta. Si creas una cuenta, eres responsable de mantener la confidencialidad de tu contraseña y de toda actividad bajo tu cuenta.

## 4. Productos, precios y disponibilidad

- Los precios se muestran en la moneda indicada al momento de la compra y pueden cambiar sin previo aviso.
- Hacemos un esfuerzo razonable para que las imágenes y descripciones sean precisas, pero al ser productos de terceros pueden existir variaciones menores entre la foto y el producto recibido (color, empaque).
- La disponibilidad de stock depende de nuestro proveedor y puede cambiar después de realizada la orden; si un producto no está disponible te notificaremos y reembolsaremos esa línea de la orden.

## 5. Pago

Los pagos se procesan a través de Stripe. Drelo no almacena los números completos de tu tarjeta. Al completar tu compra autorizas el cargo del monto total (producto + envío + impuestos aplicables) a tu método de pago.

## 6. Envíos

Ver la [Política de Envíos](./03_Shipping_Policy.md) — los tiempos de entrega en un modelo de dropshipping internacional son más largos que los de un retailer tradicional (normalmente entre 7 y 25 días hábiles).

## 7. Devoluciones y reembolsos

Ver la [Política de Devoluciones](./04_Return_Refund_Policy.md).

## 8. Reseñas y contenido subido por usuarios

Si el Sitio permite dejar reseñas de producto (incluyendo fotos), al subir contenido declaras que tienes los derechos sobre ese contenido y nos otorgas una licencia para mostrarlo en el Sitio. No se permite subir contenido que infrinja derechos de autor de terceros, sea ofensivo, o no esté relacionado con el producto. Pryma Wellness Group Inc. tiene registrado un Agente DMCA (#DMCA-1074585) y atenderá notificaciones de infracción de copyright conforme al proceso de notice-and-takedown — ver [Aviso DMCA](./05_Aviso_DMCA.md).

## 9. Uso aceptable

No puedes usar el Sitio para actividad ilegal o fraudulenta, intentar explotar nuestro sistema de cupones/descuentos de forma abusiva, ni revender productos comprados en Drelo presentándolos como productos propios sin autorización.

## 10. Limitación de responsabilidad

En la máxima medida permitida por la ley, Pryma Wellness Group Inc. no será responsable por daños indirectos, incidentales o consecuentes derivados del uso del Sitio o de los productos comprados. Nuestra responsabilidad total frente a ti no excederá el monto pagado por el pedido en cuestión.

## 11. Resolución de Disputas — Arbitraje y Renuncia a Acción Colectiva

Toda disputa relacionada con estos Términos o tu compra se resolverá mediante **arbitraje vinculante e individual** ante la American Arbitration Association (AAA), bajo la Federal Arbitration Act (FAA). **Tú y Pryma Wellness Group Inc. renuncian al derecho de participar en una demanda colectiva.** Tienes 30 días desde tu primera compra para optar por no aplicar esta cláusula, notificando por escrito a soporte@drelo.shop.

## 12. Ley aplicable

Estos Términos se rigen por las leyes del Estado de Delaware, EE.UU., salvo lo dispuesto en la Sección 11 respecto a la FAA.

## 13. Cambios

Podemos modificar estos Términos; el uso continuado del Sitio tras un cambio constituye aceptación.

## 14. Contacto

Pryma Wellness Group Inc. (operando como Drelo)
soporte@drelo.shop
`;
